import React, { useState, useRef, useEffect } from "react";
import Step1MobileLocalityForm from "./Step1MobileLocalityForm";
import Step2OtpVerificationForm from "./Step2OtpVerificationForm";
import Step3CompleteRegistrationForm from "./Step3CompleteRegistrationForm";
import { useAuth } from "../../../context/AuthContext";
import { useFlowManager } from "../../../hooks/useFlowManager.js";

const LoginSection = () => {
  const [formData, setFormData] = useState({
    phoneNumber: "",
    name: "",
    email: "",
    city: "",
    role: "admin",
    userType: "buyer-owner",
    companyName: "",
    reraNumber: "",
  });

  const [step, setStep] = useState(1);
  const [containerHeight, setContainerHeight] = useState(0);
  const step1Ref = useRef(null);
  const step2Ref = useRef(null);
  const step3Ref = useRef(null);

  const nextStep = (data) => {
    setFormData((prev) => ({ ...prev, ...data }));
    setStep((prev) => prev + 1);
  };

  const prevStep = () => setStep((prev) => prev - 1);

  useEffect(() => {
    const getActiveHeight = () => {
      let activeRef;
      if (step === 1) activeRef = step1Ref;
      else if (step === 2) activeRef = step2Ref;
      else activeRef = step3Ref;

      if (activeRef.current) {
        const height = activeRef.current.offsetHeight;
        setContainerHeight(height);
      }
    };

    // Small delay to ensure DOM is fully rendered
    const timeout = setTimeout(getActiveHeight, 50);

    return () => clearTimeout(timeout);
  }, [step]);

  const { handleLoginSuccess } = useFlowManager();
  const { loading, requestOtp, resendOtp, verifyOtp, completeRegistration } =
    useAuth();

  const onLoginSuccess = async () => {
    handleLoginSuccess();
  };

  return (
    <div className="flex items-center justify-center p-4 w-full">
      <div
        className="relative w-full max-w-md transition-all duration-300 ease-in-out"
        style={{
          height: containerHeight ? `${containerHeight}px` : "auto",
        }}
      >
        {/* Smooth crossfade animation */}
        <div
          ref={step1Ref}
          className="w-full transition-opacity duration-300"
          style={{
            opacity: step === 1 ? 1 : 0,
            pointerEvents: step === 1 ? "auto" : "none",
            position: step === 1 ? "relative" : "absolute",
            top: 0,
            left: 0,
            right: 0,
            zIndex: step === 1 ? 10 : 0,
          }}
        >
          <Step1MobileLocalityForm
            isActive={step === 1}
            onNext={nextStep}
            formData={formData}
            setFormData={setFormData}
            requestOtp={requestOtp}
            loading={loading}
          />
        </div>

        <div
          ref={step2Ref}
          className="w-full transition-opacity duration-300"
          style={{
            opacity: step === 2 ? 1 : 0,
            pointerEvents: step === 2 ? "auto" : "none",
            position: step === 2 ? "relative" : "absolute",
            top: 0,
            left: 0,
            right: 0,
            zIndex: step === 2 ? 10 : 0,
          }}
        >
          <Step2OtpVerificationForm
            isActive={step === 2}
            formData={formData}
            verifyOtp={verifyOtp}
            onNext={nextStep}
            onBack={prevStep}
            resendOtp={resendOtp}
            onLoginSuccess={onLoginSuccess}
          />
        </div>

        <div
          ref={step3Ref}
          className="w-full transition-opacity duration-300"
          style={{
            opacity: step === 3 ? 1 : 0,
            pointerEvents: step === 3 ? "auto" : "none",
            position: step === 3 ? "relative" : "absolute",
            top: 0,
            left: 0,
            right: 0,
            zIndex: step === 3 ? 10 : 0,
          }}
        >
          <Step3CompleteRegistrationForm
            formData={formData}
            setFormData={setFormData}
            onNext={nextStep}
            onBack={prevStep}
            loading={loading}
            completeRegistration={completeRegistration}
            onLoginSuccess={onLoginSuccess}
          />
        </div>
      </div>
    </div>
  );
};

export default LoginSection;
